module.exports = __webpack_public_path__ + "img/icon-deactivate_extension.e71d4050.svg";